export const PAST_DATE_LIMIT = new Date(Date.UTC(1753, 0, 1)) // January 1, 1753
export const FUTURE_DATE_LIMIT = new Date(Date.UTC(9999, 11, 31)) // December 31, 9999, 23:59:59.999
